import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { ProductCard } from "@/components/ProductCard";
import { WhatsAppButton } from "@/components/WhatsAppButton";
import { CategorySquares } from "@/components/CategorySquares";
import { captureReferral } from "@/utils/referral";
import { trackPageView } from "@/utils/analytics";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ProductPage() {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    captureReferral();
    trackPageView(`product-${id}`);
    axios.get(`${API}/products/${id}`)
      .then(res => setProduct(res.data))
      .catch(() => setError(true));
  }, [id]);

  return (
    <div className="min-h-screen bg-[#050505]" data-testid="product-page">
      <Navbar />
      <section className="py-10 px-4">
        <div className="max-w-6xl mx-auto">
          <nav className="text-sm text-[#A0A0A0] mb-6">
            <Link to="/" className="hover:text-[#00FF66] transition-colors">Inicio</Link>
            <span className="mx-2 text-white/20">/</span>
            <span className="text-white">{product?.name || "Producto"}</span>
          </nav>
          {error || product?.sold ? (
            <div className="glass-card p-10 text-center max-w-md mx-auto" data-testid="product-unavailable">
              <p className="text-white font-semibold mb-2">{product?.sold ? "Este producto ya se vendio" : "No encontramos este producto"}</p>
              <p className="text-[#A0A0A0] text-sm mb-6">Pero tenemos mas piezas que te pueden gustar.</p>
              <Link to="/" className="inline-block bg-[#00FF66] text-[#050505] px-6 py-3 font-bold rounded-full">Ver catalogo</Link>
            </div>
          ) : !product ? (
            <div className="flex justify-center py-20"><div className="w-10 h-10 border-4 border-[#00FF66] border-t-transparent rounded-full animate-spin" /></div>
          ) : (
            <div className="max-w-xs mx-auto">
              <ProductCard product={product} autoOpen />
            </div>
          )}
          <div className="mt-14">
            <h2 className="font-oswald text-xl font-bold text-white uppercase tracking-wider text-center mb-6">Ver mas</h2>
            <CategorySquares />
          </div>
        </div>
      </section>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
